/* eslint-disable */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDmxsBtm-AoA8BTzFGcg_qD3bHDeo6spHI",
    authDomain: "jayveer-astrology.firebaseapp.com",
    projectId: "jayveer-astrology",
    storageBucket: "jayveer-astrology.appspot.com",
    messagingSenderId: "927088786039",
    appId: "1:927088786039:web:6d05db51176d1812952472",
    measurementId: "G-SXC418DWGB"
};

// const firebaseConfig = {
//     apiKey: "AIzaSyALY4jSodqNk7-6EFZU9gJp_QA3F-dVhmU",
//     authDomain: "jayveer-astrology-development.firebaseapp.com",
//     databaseURL:
//       "https://jayveer-astrology-development-default-rtdb.firebaseio.com",
//     projectId: "jayveer-astrology-development",
//     storageBucket: "jayveer-astrology-development.appspot.com",
//     messagingSenderId: "1050374904331",
//     appId: "1:1050374904331:web:5c5c6ff78799dd059a450e",
//     measurementId: "G-WQVMT7B4N2",
//   };
// Initialize Firebase
export const firebase = initializeApp(firebaseConfig);
export const db = getFirestore(firebase);
